<template>
  <!-- Edit Pop-Up -->
  <div class="overlay">
    <div
      class="popUp form row d-flex justify-content-start pt-2 p-10"
      style="width: 45% !important; overflow-x: hidden"
    >
      <em
        @click="$parent.shwAddNewDmnPopUp = !$parent.shwAddNewDmnPopUp"
        class="bi-x-lg position-sticky pr-1 ml-4 d-flex justify-content-end"
        style="top: 0px"
      ></em>
      <!-- Website -->
      <div class="l-add-dmn-website-block">
        <label>Website<em class="asterisk">*</em></label>
        <v-text-field
          solo
          type="text"
          placeholder="domain.com"
          full-width
          v-model="newDmn"
          :loading="loading"
          data-qa-node="website"
          class="w-100"
        ></v-text-field>
      </div>

      <div class="d-flex justify-content-between">
        <!-- The left column -->
        <div style="width: 50%">
          <!-- <h5>Select Connection</h5>
          <div class="mr-3">
            <div>
              <label>API<em class="asterisk">*</em></label>
              <v-autocomplete
                clearable
                solo
                v-model="api_connection"
                :items="getApiConnections"
                item-value="region"
                item-text="region"
                data-qa-node="api_connection"
              >
                <template #item="{ item }">
                  <p>{{ item.region }}</p>
                </template>
              </v-autocomplete>
            </div>
          </div> -->
          <h5 v-if="permissionBlockVisibility">Copy</h5>
          <div class="mr-3">
            <div>
              <div v-if="permissionBlockVisibility">
                <label>From</label>
                <v-autocomplete
                  clearable
                  solo
                  v-model="from_dmn_val"
                  data-qa-node="from_dmn"
                  :items="domains"
                  :loading="loading"
                  item-value="id"
                  item-text="url"
                ></v-autocomplete>
              </div>
              <div v-if="permissionBlockVisibility">
                <label>Select what you need to copy</label>
                <v-autocomplete
                  clearable
                  solo
                  v-model="selectedCopyItem"
                  data-qa-node="selected_copy_entity"
                  :items="itemsForCopying"
                  :loading="loading"
                  item-value="value"
                  item-text="type"
                ></v-autocomplete>
              </div>
              <div>
                <label>Add some tags</label>
                <v-autocomplete
                  v-model="selectedTags"
                  data-qa-node="selected_tags"
                  :items="tags"
                  :loading="loading"
                  item-text="name"
                  item-value="name"
                  multiple
                  chips
                  clearable
                  deletable-chips
                  solo
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip
                      v-if="index === 0"
                      class="mr-1 ma-2 lighten-4"
                      :class="{
                        purple: item.type
                          ? item.type.includes('server')
                          : false,
                        'deep-orange': item.type
                          ? item.type.includes('category')
                          : false,
                        blue: item.type ? item.type.includes('adult') : false,
                        red: item.type ? item.type.includes('geo') : false,
                      }"
                    >
                      <span>{{ item.name }}</span>
                    </v-chip>

                    <span
                      v-if="index === 1"
                      class="mr-1 ma-2 grey--text text-caption"
                    >
                      (+{{ selectedTags.length - 1 }} others)
                    </span>
                  </template>
                </v-autocomplete>
              </div>
            </div>
          </div>
        </div>
        <!-- The right column -->
        <div style="width: 50%">
          <!-- <div class="mb-8" style="padding: 31px 0 0 0">
            <label>DataBase<em class="asterisk">*</em></label>
            <v-autocomplete
              clearable
              solo
              v-model="db_connection"
              data-qa-node="db_connections"
              :items="getDbConnections"
              height="15"
              item-value="region"
              item-text="region"
            >
              <template #item="{ item }">
                <p>{{ item.region }}</p>
              </template>
            </v-autocomplete>
          </div> -->
          <!-- Icon -->
          <!-- <div>
              <div>
                <label style="margin: 0 9px 0 0">Icon</label>
              </div>
              <v-file-input
                v-model="icon"
                full-width
                height="266"
                outlined
                class="mt-3"
                prepend-icon=""
                accept=".ico, .jpeg, .svg, .png"
              >
              </v-file-input>
            </div> -->
        </div>
      </div>
      <v-btn
        :loading="loading"
        color="success"
        elevation="2"
        small
        class="ml-3"
        style="height: 34px !important"
        @click="addDomain"
      >
        Add New Domain
      </v-btn>
    </div>

    <!-- Error Pop-Up -->
    <Error v-if="errorMsg" :error="errorMsg" />

    <!-- SnackBar -->
    <transition
      class="animate__faster"
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
    >
      <SuccessSnackbar
        v-if="success"
        @update-success="handleUpdateToSuccessSnackbar"
        message="Domain Is Successfully Added!"
      />
    </transition>

    <!-- Warning -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <Warnings
        v-if="warning"
        @didClose="warning = false"
        :warningText="warningText"
      />
    </transition>

    <!-- <v-snackbar v-model="success" color="#28a745" :top="true" timeout="1000">
      Domain Is Successfully Added!
    </v-snackbar> -->
    <v-snackbar
      v-model="withoutMandatoryFields"
      color="#e45b54"
      :top="true"
      timeout="3500"
    >
      You must fill out: connection (api, db) and website name!
    </v-snackbar>
  </div>
</template>

<script>
import Connections from "../../../apis/Connections";
import Tags from "../../../apis/Tags";
import Domains from "../../../apis/Domains";
import Segments from "../../../apis/Segments";
import Drip from "../../../apis/Drip";
import SuccessSnackbar from "../SuccessSnackbar.vue";
import Warnings from "../Warnings.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import { BSpinner } from "bootstrap-vue";
import Error from "../Error.vue";
import common from "../../../mixins/common";
import "animate.css";

export default {
  name: "AddNewDomain",
  components: {
    Error,
    SuccessSnackbar,
    Warnings,
    BSpinner,
  },
  mixins: [common],
  data() {
    return {
      warning: false,
      warningText: "",

      icon: "",
      tags: [],
      selectedTags: [],
      withoutMandatoryFields: false,
      loading: false,
      success: false,
      errorMsg: "",
      selectedCopyItem: "",
      from_dmn_val: "",
      api_connection: "",
      db_connection: "",
      to_dmn_val: "",
      dataForCopy: [],
      itemsForCopying: [
        { value: "recurring", type: "Recurring Drips" },
        { value: "welcome", type: "Welcome Drips" },
        { value: "rec_welc", type: "Recurring and Welcome" },
        { value: "audience", type: "Audience Filters" },
        { value: "aud_welc", type: "Filters and Welcome" },
      ],
      offsetWelcome: 0,
      offsetRecur: 0,
      newDmn: "",

      welcomeGroups: [],
      welcomesForCopying: [],
      recurringTemplate: {
        domain_id: null,
        type: "recurring",
        title: "",
        body: "",
        url: "",
        icon: "",
        event: null,
        offset: null,
        delivered: null,
        clicked: null,
        meta: null,
        customization: {},
        is_active: null,
        schedule: {},
        audiences: [],
      },
    };
  },
  mounted() {
    this.getConnections("?group_by=type,region&select=type,region");

    Tags.show().then((response) => {
      this.tags = response.data.data;
    });
  },
  computed: {
    ...mapState({
      connections: (state) => state.connections.connections,
      domains: (state) => state.domain.domains,
      segments: (state) => state.segment.segments,
      error: (state) => state.domain.errorDomain,
      error: (state) => state.recurringDrip.errorRecurringDrip,
      error: (state) => state.welcomeDrip.errorWelcomeDrip,
      recurring: (state) => state.push.recurring,
      multiple: (state) => state.push.recurring,
      one: (state) => state.push.recurring,
    }),
    ...mapGetters(["getDbConnections", "getApiConnections", "roles"]),
    permissionBlockVisibility() {
      return this.roles.includes("client") || this.roles.includes("admin")
        ? true
        : false;
    },
  },
  methods: {
    ...mapActions([
      "addTags",
      "store",
      "getSegments",
      "getConnections",
      "show",
    ]),
    copyRecurrings() {
      Drip.get(
        "recurring",
        `?where[domain_id]=${this.from_dmn_val}&with[schedules.audiences]=*&limit=100&offset=${this.offsetRecur}`
      ).then((response) => {
        this.offsetRecur += 100;

        for (let i in response.data.data) {
          if (response.data.data[i]["schedules"] !== undefined) {
            for (let property of Object.keys(this.recurringTemplate)) {
              if (
                property === "audiences" &&
                response.data.data[i]["schedules"][0]["audiences"].length
              ) {
                this.recurringTemplate[property] =
                  response.data.data[i]["schedules"][0]["audiences"];

                delete this.recurringTemplate[property][0]["id"];
                delete this.recurringTemplate[property][0]["updated_at"];
                delete this.recurringTemplate[property][0]["type"];
                delete this.recurringTemplate[property][0]["segment_id"];
                delete this.recurringTemplate[property][0]["is_system"];
                delete this.recurringTemplate[property][0]["is_active"];
                delete this.recurringTemplate[property][0]["created_at"];
                delete this.recurringTemplate[property][0]["pivot"];
              } else if (property === "schedule") {
                if (response.data.data[i]["schedules"][0].type === "one") {
                  this.recurringTemplate["schedule"] = this.one[0]["schedule"];

                  this.recurringTemplate["schedule"]["domain_id"] =
                    this.to_dmn_val;
                  this.recurringTemplate["schedule"]["name"] = "one";
                  this.recurringTemplate["schedule"]["type"] = "one";

                  this.recurringTemplate["schedule"]["choose_time"][0][
                    "date_start"
                  ] = response.data.data[i]["schedules"][0]["date_start"];
                  this.recurringTemplate["schedule"]["choose_time"][0][
                    "timezone"
                  ] = response.data.data[i]["schedules"][0]["timezone"];
                  this.recurringTemplate["schedule"]["choose_time"][0]["time"] =
                    response.data.data[i]["schedules"][0]["time"];
                } else if (
                  response.data.data[i]["schedules"][0].type === "recurring"
                ) {
                  this.recurringTemplate["schedule"] =
                    this.recurring[0]["schedule"];

                  this.recurringTemplate["schedule"]["domain_id"] =
                    this.to_dmn_val;
                  this.recurringTemplate["schedule"]["name"] = "recurring";
                  this.recurringTemplate["schedule"]["type"] = "recurring";
                  this.recurringTemplate["schedule"]["time"] =
                    response.data.data[i]["schedules"][0]["time"];
                  this.recurringTemplate["schedule"]["timezone"] =
                    response.data.data[i]["schedules"][0]["timezone"];
                  this.recurringTemplate["schedule"]["date_start"] =
                    response.data.data[i]["schedules"][0]["date_start"];
                  this.recurringTemplate["schedule"]["date_end"] =
                    response.data.data[i]["schedules"][0]["date_end"];
                  this.recurringTemplate["schedule"]["frequency"] =
                    response.data.data[i]["schedules"][0]["frequency"];
                }
              } else {
                this.recurringTemplate[property] =
                  response.data.data[i][property];
              }
            }

            response.data.data[i] = JSON.parse(
              JSON.stringify(this.recurringTemplate)
            );
          }

          response.data.data[i]["domain_id"] = this.to_dmn_val;
          response.data.data[i]["schedule"]["domain_id"] = this.to_dmn_val;

          response.data.data[i]["audiences"] !== undefined &&
          response.data.data[i]["audiences"].length
            ? (response.data.data[i]["audiences"][0]["domain_id"] =
                this.to_dmn_val)
            : null;
        }

        return new Promise((resolve, reject) => {
          Drip.createOrUpdate("recurring", response.data.data).catch(
            (error) => {
              reject(error);

              if (error.response) {
                this.errorMsg = error.response.data.message;
                setTimeout(() => {
                  this.errorMsg = "";
                }, 1000);
              }
            }
          );

          if (response.data.data.length) {
            resolve(response);

            this.copyRecurrings();
          } else {
            reject("Empty array");
          }
        });
      });
    },
    copyWelcomes() {
      Drip.get(
        "welcome",
        `?group_by=group_id&where[domain_id]=${this.from_dmn_val}&with[schedules]=name,type,is_active,after_days,after_mins,after_hours&limit=100&offset=${this.offsetWelcome}`
      ).then((response) => {
        if (response.data.data.length) {
          this.offsetWelcome += 100;

          this.welcomeGroups = response.data.data;

          for (let i in this.welcomeGroups) {
            Drip.get(
              "welcome",
              `?where[domain_id]=${this.welcomeGroups[i].domain_id}&where[group_id]=${this.welcomeGroups[i].group_id}&with[schedules]=name,type,is_active,after_days,after_mins,after_hours,from_when`
            ).then(async (response) => {
              if (response.data.data.length) {
                this.welcomesForCopying = response.data.data.reduce(
                  (array, obj) => {
                    obj.domain_id = this.to_dmn_val;
                    obj.schedule = obj.schedules[0];
                    delete obj.id;
                    delete obj.group_id;
                    delete obj.schedules;

                    array.push(obj);
                    return array;
                  },
                  []
                );
              }

              return new Promise((resolve, reject) => {
                Drip.createOrUpdate("welcome", this.welcomesForCopying).catch(
                  (error) => {
                    reject(error);

                    if (error.response) {
                      this.errorMsg = error.response.data.message;
                      setTimeout(() => {
                        this.errorMsg = "";
                      }, 1000);
                    }
                  }
                );

                if (response.data.data.length) {
                  resolve(response);

                  this.copyWelcomes();
                } else {
                  reject("Empty data.");
                }
              });
            });
          }
        }
      });
    },
    copyAudiences() {
      this.getSegments(
        `?where[type]=audience&where[domain_id]=${this.from_dmn_val}&where[is_system]=0`,
      ).then(async (response) => {
        for (let el of response.data.data) {
          await this.getSegments(
            `?where[name]=${el.name}&where[query]=${JSON.stringify(
              el.query
            )}&where[domain_id]=${this.to_dmn_val}`
          ).then((response) => {
            if (!response.data.data.length) {
              Segments.store({
                name: el.name,
                query: el.query,
                domain_id: this.to_dmn_val,
                type: "audience",
              });
            }
          });
        }
      });
    },
    addDomain() {
      if (this.from_dmn_val && !this.selectedCopyItem) {
        this.warningText = "Select what type of content you need to copy.";
        this.warning = true;

        return false;
      }

      if (!this.from_dmn_val && this.selectedCopyItem) {
        this.warningText = "Select which domain you need to copy content from.";
        this.warning = true;

        return false;
      }

      if (this.newDmn) {
        this.loading = true;

        let json = {
          url: this.newDmn,
          fcm_conf: "client",
        };

        // queueMicrotask(() => {
        //   this.loading = false;
        // });

        Domains.store(json)
          .then((dmnResponse) => {
            this.to_dmn_val = dmnResponse.data.data.id;

            if (
              typeof this.selectedTags !== "string" &&
              this.selectedTags.length
            ) {
              let urlParams = this.selectedTags
                .map((el) => {
                  return "tags[]=" + el;
                })
                .join("&");

              Domains.addTags(dmnResponse.data.data.website_id, urlParams)
                .then(() => {
                  dmnResponse.data.data.domain_tags = this.selectedTags.map(
                    (el) => ({ name: el.name })
                  );

                  this.show();
                })
                .then(() => {
                  if (!this.selectedCopyItem) {
                    // setTimeout(() => {
                    //   this.$parent.shwAddNewDmnPopUp = false;
                    // }, 4000);
                  }
                });
            }

            this.$store.state.domain.domains.push(dmnResponse.data.data);

            if (this.selectedCopyItem === "recurring") {
              this.copyRecurrings();
            } else if (this.selectedCopyItem === "welcome") {
              this.copyWelcomes();
            } else if (this.selectedCopyItem === "audience") {
              this.copyAudiences();
            } else if (this.selectedCopyItem === "rec_welc") {
              this.copyRecurrings();
              this.copyWelcomes();
            } else if (this.selectedCopyItem === "aud_welc") {
              this.copyAudiences();
              this.copyWelcomes();
            }
          })
          .then(() => {
            this.show();

            setTimeout(() => {
              this.success = true;
              this.loading = false;
            }, 1500);

            setTimeout(() => {
              if (this.to_dmn_val) {
                this.$router.push({ name: "Integrate2", params: { id: this.to_dmn_val } })
              } else {
                this.$emit("close", false);
              }
            }, 3000);
          })
          .catch((err) => {
            this.loading = false;

            if (err.response !== undefined && err.response.status == 404) {
              this.errorMsg = "This url has been created.";
            } else {
              this.errorMsg = "Error";
            }
          });
      } else if (!this.newDmn) {
        this.withoutMandatoryFields = true;
        this.loading = false;
      }
    },
  },
  // watch: {
  //   error() {
  //     if (this.error) {
  //       this.loading = false;
  //     }
  //   },
  //   domains() {
  //     if (this.domains.length || this.domains.length === 0 || this.error) {
  //       this.loading = false;
  //     }
  //   },
  // },
};
</script>

<style scoped>
html,
body,
.container {
  height: 100%;
}
.container-fluid div:nth-child(1),
.container-fluid div:nth-child(2),
.container-fluid {
  display: flex;
}
.container-fluid > * {
  width: 350px;
}
.container-fluid {
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
label {
  width: 65px;
}
button {
  width: auto !important;
  margin: 21px;
  cursor: pointer;
}
@media (max-width: 414px) {
  #dropdownMenuButton {
    max-width: 160px;
  }
}
@media (max-width: 280px) {
  #dropdownMenuButton {
    max-width: 110px !important;
    margin-right: 0;
  }
}
</style>
